import React, { Component } from 'react';
import './TaskList.css';

class TasksList extends Component{
    constructor(props){
        super(props);
        this.state = {
            isEditing : false,
            editedTodo : ''
        }
        this.deleteTodo = this.deleteTodo.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.saveEdited = this.saveEdited.bind(this);
        this.checkOut = this.checkOut.bind(this);
    }
    checkOut(){
        this.props.handleCheckOut(this.props.todo,this.props.todoObj.isCheckedOut);
    }
    handleChange(evt){
        this.setState ({[evt.target.name] : [evt.target.value]})
    }
    saveEdited(){
        this.props.handleSave(this.props.todo, this.state.editedTodo);
    }
    deleteTodo(){
        this.props.handleDelete(this.props.todo)
    }
    handleEdit(){
        this.setState ({isEditing : !this.state.isEditing})
    }
    render(){
        const context = this.state.isEditing ? 
            <div className='EditTask' 
            style={{backgroundColor: this.props.darkTheme ? 'hsl(235, 24%, 19%)' : 'white'}}
            >
                <input 
                type= 'text'
                value = {this.state.editedTodo}
                onChange = {this.handleChange}
                name = 'editedTodo'
                />
                <button onClick = {this.saveEdited}
                style = {{backgroundColor : this.state.darkTheme ? 'hsl(235, 21%, 11%)' : 'hsl(235, 21%, 11%)',
                color : !this.state.darkTheme && 'white'}}
                >Save</button>
            </div> 
            : 
            <div className='TasksList'
            style={{backgroundColor : this.props.darkTheme ? 'hsl(235, 24%, 19%)' : 'white',
                border : this.props.darkTheme ? '.65px solid rgb(59, 56, 56)' : '.65px solid  hsl(234, 39%, 85%)'}}
            >
                <div>
                    <div className= {`checkoutDiv ${this.props.checkedOutStatus && 'checkedOut'}`} onClick={this.checkOut}>
                        {this.props.checkedOutStatus && <img src = {require('./icon-check.svg').default} alt = 'check'/>}
                    </div>
                    <span style =
                        {{textDecoration : this.props.checkedOutStatus ? 'line-through' : 'none',
                        color : this.props.darkTheme ? 'white' : 'black'}}>
                        {this.props.todo}
                    </span>
                </div>
                <div>
                    <button onClick={this.handleEdit}>Edit</button>
                    <span className='del' onClick={this.deleteTodo} 
                    style = {{color : this.props.darkTheme ? 'white' : 'black'}}>X</span>
                </div>
            </div>
        return(
            <div>
                {context}
            </div>
        )

    }
}

export default TasksList;